const state = () => ({
  departamentos: [],
  provincias: [],
  distritos: [],
})

const mutations = {
  setDepartamentos(state, data) {
    state.departamentos = data
  },
  setProvincias(state, data) {
    state.provincias = data
  },
  setDistritos(state, data) {
    state.distritos = data
  },
}

const actions = {
  async loadUbigeo({ commit }) {
    // Verifica si ya están en localStorage
    const departamentosLS = localStorage.getItem('departamentos')
    const provinciasLS = localStorage.getItem('provincias')
    const distritosLS = localStorage.getItem('distritos')

    if (departamentosLS && provinciasLS && distritosLS) {
      // Si ya existen, usar desde localStorage
      commit('setDepartamentos', JSON.parse(departamentosLS))
      commit('setProvincias', JSON.parse(provinciasLS))
      commit('setDistritos', JSON.parse(distritosLS))
    } else {
      // Cargar desde archivos locales
      const deps = await fetch('/api/peru/departamentos.json').then(r => r.json())
      const provs = await fetch('/api/peru/provinciasAll.json').then(r => r.json())
      const dists = await fetch('/api/peru/distritosAll.json').then(r => r.json())

      // Guardar en localStorage
      localStorage.setItem('departamentos', JSON.stringify(deps.departamentos))
      localStorage.setItem('provincias', JSON.stringify(provs.provincias))
      localStorage.setItem('distritos', JSON.stringify(dists.distritos))

      // Guardar en Vuex
      commit('setDepartamentos', deps.departamentos)
      commit('setProvincias', provs.provincias)
      commit('setDistritos', dists.distritos)
    }
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};